import React from 'react';
import RemoveLastDirectoryPartOf from '../goBackButton';

const Contact = () => {
    return (
        <div className="container">
            <div className="m-2" style={{ fontSize: '20px', display: 'flex' }}>
                <div className="mr-4">
                    <a
                        href={RemoveLastDirectoryPartOf(window.location.href)}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="fe fe-arrow-left" />
                    </a>
                </div>
                <div>Contact KSJC</div>
            </div>
            <div className="card">
                <div
                    style={{ padding: '5px' }}
                    className="card-body text-center"
                >
                    <div className=" mb-1">
                        For More information contact us at
                        <div>
                            <a href="tel:9440302664">+91-9440302664</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
